import $ from "jquery";

// eslint-disable-next-line no-undef
const adminAjax = contrave.ajax_url;

console.log("Enrollment page script loaded");

function getQueryParameters(str) {
  return (str || document.location.search)
    .replace(/(^\?)/, "")
    .split("&")
    .map(
      function (n) {
        return (n = n.split("=")), (this[n[0]] = n[1]), this;
      }.bind({})
    )[0];
}

/** Enrollment page only: format as ###-###-#### from any pasted/typed string. */
function formatEnrollmentPhoneFromString(value) {
  const d = String(value ?? "")
    .replace(/\D/g, "")
    .slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
}

function syncEnrollmentPhoneInput(el) {
  const raw = el.value;
  const selStart =
    typeof el.selectionStart === "number" ? el.selectionStart : raw.length;
  const digitsBeforeCursor = raw.slice(0, selStart).replace(/\D/g, "").length;
  const formatted = formatEnrollmentPhoneFromString(raw);
  if (formatted === raw) return;
  el.value = formatted;
  let pos = formatted.length;
  let digitCount = 0;
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) digitCount++;
    if (digitCount >= digitsBeforeCursor) {
      pos = i + 1;
      break;
    }
  }
  el.setSelectionRange(pos, pos);
}

/** Enrollment page only: format as MM/DD/YYYY from digits (max 8 → MMDDYYYY). */
function formatEnrollmentDobFromString(value) {
  const d = String(value ?? "")
    .replace(/\D/g, "")
    .slice(0, 8);
  if (d.length <= 2) {
    return d;
  }
  if (d.length <= 4) {
    return `${d.slice(0, 2)}/${d.slice(2)}`;
  }
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
}

function syncEnrollmentDobInput(el) {
  const raw = el.value;
  const selStart =
    typeof el.selectionStart === "number" ? el.selectionStart : raw.length;
  const digitsBeforeCursor = raw.slice(0, selStart).replace(/\D/g, "").length;
  const formatted = formatEnrollmentDobFromString(raw);
  if (formatted === raw) {
    return;
  }
  el.value = formatted;
  let pos = formatted.length;
  let digitCount = 0;
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) {
      digitCount++;
    }
    if (digitCount >= digitsBeforeCursor) {
      pos = i + 1;
      break;
    }
  }
  el.setSelectionRange(pos, pos);
}

const sections = {
  start: {
    id: "#cupon-get-started",
  },
  insurance: {
    id: "#cupon-insurance-select",
    class: "cupon-insurance-select",
  },
  contact: {
    id: "#cupon-private-health",
  },
  ineligible: {
    id: "#ineligible",
  },
  insurance_none: {
    id: "#ineligible",
    class: "no-insurance-note",
  },
  success_card: {
    id: "#cupon-thank-you",
    class: "no-insurance-note-thanks",
  },
  existing_member: {
    id: "#cupon-private-health",
    modal: "modal-existing_member",
  },
  // Add more sections here
};

class EnrollmentPage {
  #savings_card = "";
  constructor(savings_card) {
    this.#savings_card = savings_card;
    this.stepsPath = ["start"];
    this.card_id = null;
    this.bindEvents();
    this.redirectIfInvalidData(this.restoreData());
  }
  /**
   * Bind all events on the page
   */
  bindEvents() {
    console.log("bind events");
    $("[data-next]").on("click", (e) => {
      console.log("next clicked");
      e.preventDefault();
      this.handleNext();
    });
    $("input[name='INSURANCE']").on("change", (e) => {
      e.preventDefault();
      this.handleNext();
    });
    $("[data-back]").click((e) => {
      e.preventDefault();
      this.handleBack();
    });

    // $("[data-set-input]").click(this.setInput);
    // $("[data-custom-check]").on("click", this.handleCheckClick);
    console.log($("input[name='Q_PERM_OPT_IN']"));

    $("input[name='Q_PERM_OPT_IN']").on("change", function () {
      // Check if the checkbox is checked or not
      const optIn = $(this).is(":checked");
      if (optIn) {
        $("input[name='Q_PERM_OPT_IN']").val("Y");
      } else {
        $("input[name='Q_PERM_OPT_IN']").val("N");
      }

      console.log({ optIn }); // Logs true if checked, false if unchecked
    });
    $("[data-print]").click((e) => this.handlePrint(e));
    $("[data-download-card]").click((e) => this.handleDownloadPdf(e));
    this.bindEnrollmentPhoneMask();
    this.bindEnrollmentDobMask();
    $("input").on("input", this.validateNext);
    $("[data-submit-page]").click(() => {
      this.handleSubmit();
    });

    window.onpopstate = this.handlePopstate;
  }

  /**
   * Auto-insert hyphens for mobile phone on the enrollment form only (#enrollment_page_form).
   */
  bindEnrollmentPhoneMask() {
    const $phone = $("#enrollment_page_form input[name='Q_MOBILE_PHONE']");
    $phone.on("input", function () {
      syncEnrollmentPhoneInput(this);
    });
    $phone.on("paste", function () {
      const el = this;
      setTimeout(() => syncEnrollmentPhoneInput(el), 0);
    });
  }

  /**
   * Auto-insert slashes for date of birth on the enrollment form only (#enrollment_page_form).
   */
  bindEnrollmentDobMask() {
    const $dob = $("#enrollment_page_form input[name='Q_DOB']");
    $dob.on("input", function () {
      syncEnrollmentDobInput(this);
    });
    $dob.on("paste", function () {
      const el = this;
      setTimeout(() => syncEnrollmentDobInput(el), 0);
    });
  }

  /**
   * Determine if data has already been set to session and auto-populate
   */
  restoreData() {
    let data = this.getSessionData();
    console.log({ data });
    const params = getQueryParameters();
    const cardId = params.card_id;

    if (!data || !Object.keys(data).length) {
      data = this.getFormData();
    }

    if (cardId) {
      this.createCardImage(cardId);
    }

    if (!data.card_id && cardId) {
      data.card_id = cardId;
    }

    this.setSessionData(data);
    this.setFormData(data);

    this.validateNext();

    return data;
  }
  /**
   * Get parsed form data from the session
   */
  getSessionData() {
    return this.parseData(
      JSON.parse(window.sessionStorage.getItem("enrollment_data"))
    );
  }
  /**
   * Set data to the session
   *
   * @param {any} data Data fo the enrollment
   */
  setSessionData(data) {
    window.sessionStorage.setItem("enrollment_data", JSON.stringify(data));
    return data;
  }
  /**
   * Get parsed form data from the front-end form
   */
  getFormData() {
    const contactData = this.parseData(
      $("#enrollment_page_form")
        .serializeArray()
        .reduce((obj, item) => {
          obj[item.name] = item.value;
          return obj;
        }, {})
    );

    const insuranceSelect = this.parseData(
      $("#cupon-select-coverage input:checked")
        .serializeArray()
        .reduce((obj, item) => {
          obj[item.name] = item.value;
          return obj;
        }, {})
    );
    return {
      ...contactData,
      ...insuranceSelect,
    };
  }
  /**
   * Loop over a data object to set associated form values.
   * Update check boxes where applicable
   *
   * @param {any} data Some data
   */
  setFormData(data) {
    for (const name in data) {
      if (Object.hasOwnProperty.call(data, name)) {
        $(`#enrollment_page_form [name="${name}"]`).val(data[name]);
      }
    }

    const $phoneRestore = $("#enrollment_page_form input[name='Q_MOBILE_PHONE']");
    if ($phoneRestore.length && Object.prototype.hasOwnProperty.call(data, "Q_MOBILE_PHONE")) {
      $phoneRestore.val(formatEnrollmentPhoneFromString(data.Q_MOBILE_PHONE));
    }

    const $dobRestore = $("#enrollment_page_form input[name='Q_DOB']");
    if ($dobRestore.length && Object.prototype.hasOwnProperty.call(data, "Q_DOB")) {
      $dobRestore.val(formatEnrollmentDobFromString(data.Q_DOB));
    }

    // if (data.Q_VALID_RX === "Y") {
    //   $(".prescription [data-custom-check]").eq(0).addClass("checked");
    //   $(".prescription .btn").removeClass("disabled");
    // }
    // if (data.Q_VALID_RX === "N") {
    //   $(".prescription [data-custom-check]").eq(1).addClass("checked");
    //   $(".prescription .btn").removeClass("disabled");
    // }
    // if (data.Q_HOW_LONG) {
    //   $(".term [data-custom-check]")
    //     .eq(data.Q_HOW_LONG - 1)
    //     .addClass("checked");
    //   $(".term .btn").removeClass("disabled");
    // }
    data.Q_HOW_LONG = 1;
    data.Q_VALID_RX = "N";
    if (data.INSURANCE) {
      $(".insurance [data-custom-check]")
        .eq(data.INSURANCE - 1)
        .addClass("checked");
      $(".insurance .btn").removeClass("disabled");
    }
    if (data.Q_STATE) {
      $("[state-dropdown] button").text(data.Q_STATE);
    }
    if (data?.Q_PERM_OPT_IN === "Y") {
      $(".contact .agree [data-custom-check]").addClass("checked");
    }
    if (data.card_id) {
      $(".display_card_id").text(data.card_id);
    }

    return data;
  }
  /**
   * Parse raw form data, transforming values where needed
   *
   * @param {any} data Data in general
   */
  parseData(data) {
    for (const name in data) {
      if (
        Object.hasOwnProperty.call(data, name) &&
        ["Q_HOW_LONG", "INSURANCE"].includes(name)
      ) {
        data[name] = parseInt(data[name], 10);
      }
    }
    return data;
  }
  redirectIfInvalidData(data) {
    let redirect_to = null;
    const valid_prescription = data.Q_VALID_RX;
    const valid_term = data.Q_HOW_LONG;

    const valid_insurance = data.Q_INSURANCE && data.Q_INSURANCE_TYPE;

    switch (this.getCurrentStep()) {
      case "contact":
      case "ineligible":
      case "insurance_none":
        redirect_to = valid_insurance ? redirect_to : "insurance";
        break;
      case "insurance":
        redirect_to = valid_term ? redirect_to : "term";
        break;
      case "term":
        redirect_to = valid_prescription ? redirect_to : "prescription";
        break;
      default:
        break;
    }

    // redirect back to start page if connect only (not back to interstitial pages)
    if (redirect_to) {
      window.location = this.getStepUrl(redirect_to);
    }
  }
  /**
   * Generate the url of a given step in the form flow
   */
  getStepUrl(step) {
    const base_url = `//${window.location.host}${window.location.pathname}`;
    const params = getQueryParameters();

    params.step = step;
    return `${base_url}?${$.param(params)}`;
  }
  /**
   * Get the current step in the form flow
   */
  getCurrentStep() {
    const params = getQueryParameters();
    // return params.step || "start";
    return this.step || "insurance";
  }
  /**
   * Go to the next step in the form, saving state & form data along the way
   */
  goToNextStep(next, data) {
    // let url = this.getStepUrl(next);
    // if (data.card_id) {
    //   url = `${url}&card_id=${data.card_id}`;
    // }

    // history.pushState(data, next, url);
    // $("main").attr("data-step", next);
    this.stepsPath.push(next);
    this.toggleNextStep(next);
    this.validateNext();
  }
  /**
   * Hide all errors on the page
   */
  hideErrors() {
    $("[data-show-error]").hide();
    $("[data-show-error]").parent().removeClass("is-showing-error");
  }
  /**
   * Show an error on the page
   */
  showError(error_name, message) {
    $(`[data-show-error="${error_name}"]`).text(message).show().css("color", "red");
    $(`[data-show-error="${error_name}"]`)
      .parent()
      .addClass("is-showing-error");
  }
  /**
   * Next button handler. Handle everything that is needed to validate current data and progress to the next step in the form
   */

  handleSubmit() {
    console.log(this);
    let data = this.getFormData();
    const errors = this.validate("contact", data);
    this.hideErrors();
    console.log({ data, errors });

    if (Object.keys(errors).length) {
      Object.keys(errors).forEach((error_name) => {
        this.showError(error_name, errors[error_name]);
      });
      return;
    }

    this.doSubmit(data);
  }
  handleNext() {
    console.log("handle next");
    let data = this.getFormData();
    console.log({ data });
    const current_step = this.getCurrentStep();
    console.log({ current_step });

    if (current_step === "start") {
      window.dataLayer?.push({ event: "sc_next_info" });
    }

    if (current_step === "insurance") {
      if (data.INSURANCE === 1) {
        window.dataLayer?.push({ event: "sc_next_private" });
      }
      if (data.INSURANCE === 2) {
        window.dataLayer?.push({ event: "sc_next_medicare" });
      }
      if (data.INSURANCE === 3) {
        window.dataLayer?.push({ event: "sc_next_medicaid" });
      }
      if (data.INSURANCE === 4) {
        window.dataLayer?.push({ event: "sc_next_tricare" });
      }
      if (data.INSURANCE === 5) {
        window.dataLayer?.push({ event: "sc_next_other" });
      }
      if (data.INSURANCE === 6) {
        window.dataLayer?.push({ event: "sc_next_noinsurance" });
      }
    }

    const errors = this.validate(current_step, data);
    console.log({ errors });
    let next_step;

    this.hideErrors();

    if (Object.keys(errors).length) {
      Object.keys(errors).forEach((error_name) => {
        this.showError(error_name, errors[error_name]);
      });
      return;
    }

    next_step = this.getNextStep(current_step, data);
    console.log({ next_step });
    data = this.updateFormData(current_step, data);

    this.setSessionData(data);

    if (next_step === "submit") {
      this.doSubmit(data);
    } else {
      this.goToNextStep(next_step, data);
    }
  }
  /**
   * Back button handler
   */
  handleBack() {
    console.log("handle back");
    console.log(this.stepsPath);
    let data = this.getFormData();

    this.stepsPath.pop();
    const previousStep = this.stepsPath.slice(-1)[0];
    this.goToNextStep(previousStep, data);
    this.hideErrors();
  }
  /**
   * Quick method of setting a value to an input element on click
   */
  setInput(e) {
    const name = $(this).data("set-input");
    const value = $(this).data("value");

    $(`#enrollment_page_form [name="${name}"]`).val(value);

    if (!$(this).is("[data-is-dropdown-link]")) {
      return;
    }
    $(this)
      .parents(".dropdown-menu")
      .siblings(".dropdown-toggle")
      .text($(this).text());
    $(this)
      .parents(".dropdown-menu")
      .siblings(".dropdown-toggle")
      .dropdown("toggle");
    e.preventDefault();
    e.stopPropagation();
  }
  /**
   * Handle a click on one of the custom check boxes (which are actually just 2 images).
   * Supports multiple choices by putting the data-multiple-check attribute on the target element.
   */
  handleCheckClick(_e) {
    const accept = $(this).hasClass("accept");
    const checked = $(this).hasClass("checked");

    if (accept) {
      $(this).toggleClass("checked");
      $(this)
        .parents(".is-showing-error")
        .removeClass("is-showing-error")
        .find("[data-show-error]")
        .text("");
    } else if (!checked) {
      $(this)
        .parents("section")
        .find("[data-custom-check]")
        .removeClass("checked");
      $(this).addClass("checked");
      $(this)
        .parents(".is-showing-error")
        .removeClass("is-showing-error")
        .find("[data-show-error]")
        .text("");
    }

    Enrollment.prototype.validateNext();
  }
  /**
   * Handle forward & back buttons being pressed
   */
  handlePopstate(e) {
    const params = getQueryParameters();
    $("main").attr("data-step", params.step || "insurance");
  }
  handleSuccess(response, data) {
    $(".contact .btn").removeClass("disabled");
    if (response.card_id) {
      data.card_id = response.card_id;
      this.createCardImage(data.card_id);
    }
    this.card_id = response.card_id;
    window.dataLayer?.push({
      event: "savings_card_enrollment",
      page_name: "savings_card_completion",
    });
    this.setFormData(data);
    this.goToNextStep(this.getNextStep("submit", data), data);

    setTimeout(function () {
      var el = document.getElementById("cupon-thank-you");
      if (el && !el.classList.contains("d-none")) {
        var headerHeight = document.querySelector("header")
          ? document.querySelector("header").offsetHeight
          : 80;
        var top =
          el.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
        window.scrollTo({ top: top, behavior: "smooth" });
        el.setAttribute("tabindex", "-1");
        el.focus({ preventScroll: true });
      }
    }, 150);
  }
  handleCardExists(data) {
    $(".contact .btn").removeClass("disabled");
    this.setFormData(data);
    this.goToNextStep("existing_member", data);
  }
  doSubmit(data) {
    document.querySelector('#enrollment_page_form button').disabled = true;
    const url = $("#enrollment_page_form").attr("action");
    const _this = this;

    $(".contact .btn").addClass("disabled");
    $.ajax({
      type: "POST",
      url: adminAjax,
      data: {
        action: "execute_enrollment",
        data,
      },
      success(_response, textStatus, xhr) {
        document.querySelector('#enrollment_page_form button').disabled = false;
        const response =
          typeof _response === "object" ? _response : JSON.parse(_response);
        console.log({ response });
        const cardExistsMessage =
          "Sorry, but it appears that you are already a member of the CurAccess Program. Please call 1-800-905-5576 to obtain your existing Member ID";
        const cardExists = response.code === "E541";

        const isValidResponse = response.code === 200 || response.code === true;

        if (cardExists) {
          console.log(cardExistsMessage);
          _this.handleCardExists(data);
          return;
        }

        if (response.error || !isValidResponse) {
          console.error("Error submitting form");
          _this.handleError(response, data);
          return;
        }
        // console.log("Success submitting form", response, data);
        window.gtag?.(
          "send",
          "event",
          "Enroll Now-Finish",
          "Button Click",
          "hardconversion:finish"
        );
        _this.handleSuccess(response, data);
        $("#coupon-card-id").html(
          `Your CONTRAVE <br class="d-inline-block d-lg-none"> Savings Card account <br class="d-inline-block d-lg-none"> ID number is: <br class="d-inline-block d-lg-none"> <span>${response.card_id}</span>`
        );
      },
      error(xhr, textStatus, errorThrown) {
        document.querySelector('#enrollment_page_form button').disabled = false;
        console.error("Client request error.");
        _this.handleError(
          {
            code: xhr.status || "ES5",
            message: xhr.statusText || "Unknown client request error.",
          },
          data
        );
      },
    });
  }
  handleError(response, data) {
    console.error("Code:", response.code || "No Code");
    console.error("Message:", response.message || "");
    console.error("Response:", response || null);
    console.error("User data:", data || null);

    $(".contact .btn").removeClass("disabled");

    // IMPORTANT: "ES" Error codes come from our own backend (Studio). These signify validation errors or connection errors on our end.
    //            "E###" Error codes come directly from the McKesson API.
    if (response.code) {
      switch (response.code) {
        case "ES1":
        case "ES6":
        case "E011":
        case "E012":
        case "E013":
        case "E014":
        case "E311":
          this.showError(
            "CONTACT_GENERAL",
            "Sorry, we are unable to connect to our enrollment service at this time. Please try again later."
          );
          break;
        case "E000":
          this.showError(
            "CONTACT_GENERAL",
            "Sorry, an unknown error occurred with our enrollment service. Please try again later."
          );
          break;
        case "E137":
        case "E401":
        case "E403":
        case "E404":
          this.showError(
            "CONTACT_GENERAL",
            "Invalid data entered in one or more fields."
          );
          break;
        case "E101":
          this.showError(
            "CONTACT_GENERAL",
            "One or more required fields are missing."
          );
          break;
        case "E402":
        case "E542":
          this.showError("CONTACT_GENERAL", "An incorrect date was entered.");
          break;
        case "E503":
          this.showError(
            "CONTACT_GENERAL",
            "Card ID not valid for this program."
          );
          break;
        case "E511":
          this.goToNextStep("ineligible", data);
          break;
        case "E989":
          this.showError(
            "insurance",
            "You must provide insurance information before enrolling."
          );
          this.goToNextStep("insurance", data);
          break;
        case "E900":
          this.showError(
            "term",
            "You must provide usage history before enrolling."
          );
          this.goToNextStep("term", data);
          break;
        case "E502":
        case "E541":
          // TODO: Review the error E541.
          this.showError(
            "CONTACT_GENERAL",
            // "A card ID is already associated with this customer."
            "Sorry, but it appears that you are already a member of the CurAccess Program. Please call 1-800-905-5576 to obtain your existing Member ID."
          );
          this.goToNextStep("existing_member", data);
          break;
        case "ES2":
          response.fields.forEach(function (field) {
            switch (field) {
              case "Q_FIRSTNAME":
                this.showError(field, "You must enter a first name.");
                break;
              case "Q_LASTNAME":
                this.showError(field, "You must enter a last name.");
                break;
              case "Q_EMAIL":
                this.showError(field, "You must enter a valid email.");
                break;
              case "Q_ZIP":
                this.showError(field, "You must enter a zip code.");
                break;
              case "Q_DOB":
                this.showError(field, "You must enter a date of birth.");
                break;
              case "Q_GENDER":
                this.showError(field, "You must enter a gender.");
                break;
              case "Q_MOBILE_PHONE":
                this.showError(
                  field,
                  "Please enter a 10-digit phone number in ###-###-#### format. Example: 123-456-7890"
                );
                break;
              case "Q_PERM_OPT_IN":
                this.showError(field, "You must check the box to proceed.");
                break;
              default:
                break;
            }
          });
          break;
        case "ES3":
          response.fields.forEach(function (field) {
            switch (field) {
              case "Q_FIRSTNAME":
                this.showError(field, "Invalid first name entered.");
                break;
              case "Q_LASTNAME":
                this.showError(field, "Invalid last name entered.");
                break;
              case "Q_EMAIL":
                this.showError(field, "You must enter a valid email address.");
                break;
              case "Q_ZIP":
                this.showError(field, "Zip code must be 5 numerical digits.");
                break;
              case "Q_DOB":
                this.showError(
                  field,
                  "Date of birth must be formatted MM/DD/YYYY"
                );
                break;
              case "Q_MOBILE_PHONE":
                this.showError(
                  field,
                  "Please enter a valid 10-digit phone number in ###-###-#### format. Example: 123-456-7890"
                );
                break;
              case "Q_ADDRESS1":
                this.showError(field, "Invalid address entered.");
                break;
              case "Q_CITY":
                this.showError(field, "Invalid city entered.");
                break;
              case "Q_STATE":
                this.showError(field, "Invalid state selected.");
                break;
              case "Q_CARD_ID":
                this.showError(field, "Card ID must be 10 numerical digits...");
                break;
              default:
                break;
            }
          });
          break;
        case "ES4":
          this.showError(
            "CONTACT_GENERAL",
            "Sorry, our enrollment service is down at this time. Please try again later."
          );
          break;
        default:
          // TODO: Validate the following
          this.showError(
            "UNKOWN",
            "Sorry, an unknown error has occurred. Please try again later."
          );
          break;
      }
    }
  }
  /**
   * Update form data after each step based on user's answers
   */
  updateFormData(step, data) {
    switch (step) {
      // case "prescription":
      //   if (data.Q_VALID_RX === "N") {
      //     data.Q_HOW_LONG = 1;
      //   }
      //   break;
      case "insurance":
        data.Q_INSURANCE = "Y";
        if (data.INSURANCE === 1) {
          // private
          data.Q_INSURANCE_TYPE = 1;
        }
        if (data.INSURANCE === 2) {
          // medicare
          data.Q_INSURANCE_TYPE = 2;
        }
        if (data.INSURANCE === 3 || data.INSURANCE === 5) {
          // medicaid, govt. sponsored
          data.Q_INSURANCE_TYPE = 3;
        }
        if (data.INSURANCE === 4) {
          // tricare
          data.Q_INSURANCE_TYPE = 4;
        }
        if (data.INSURANCE === 6) {
          // none
          data.Q_INSURANCE_TYPE = 6;
          data.Q_INSURANCE = "N";
          data.Q_INSURANCE_TYPE = null;
          data.Q_INSURANCE_PROVIDER = null;
          data.Q_EMPLOYER = null;
        }
        break;
      case "contact":
        if (data.DOB) {
          data.Q_DOB = data.DOB;
        }
        break;
      default:
        break;
    }

    return this.setFormData(data);
  }
  /**
   * Determine the next step based on the current step & submitted values
   */
  getNextStep(step, data) {
    let next;
    switch (step) {
      // case "prescription":
      //   next = "insurance";
      //   if (data.Q_VALID_RX === "Y") {
      //     next = "term";
      //   }
      //   break;
      // case "term":
      //   next = "insurance";
      //   break;
      case "start":
        next = "insurance";
        break;
      case "insurance":
        next = "contact";
        if (data.INSURANCE >= 2 && data.INSURANCE <= 5) {
          next = "ineligible";
        }

        if (data.INSURANCE === 6) {
          next = "insurance_none";
        }
        console.log({ next });
        break;
      case "insurance_none":
        next = "contact";
        break;
      case "contact":
        next = "submit";
        break;
      case "submit":
        next = "success_card";
        break;
      case "existing_member":
        next = "existing_member";
        break;
      default:
        throw new Error("Next step not found");
    }
    return next;
  }
  /**
   * Validate the submitted data for the current step
   */
  validate(step, data) {
    const errors = {};

    // TODO: Validate regex email
    const email_re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    switch (step) {
      case "start":
        break;
      case "insurance_none":
        break;
      // case "prescription":
      //   if (!data.Q_VALID_RX) {
      //     errors.prescription = "You must select an option.";
      //   }
      //   break;
      // case "term":
      //   if (!data.Q_HOW_LONG) {
      //     errors.term = "You must select an option.";
      //   }
      //   break;
      case "insurance":
        if (!data.INSURANCE) {
          errors.insurance = "You must select an option.";
        }
        break;
      case "contact":
        if (!data.Q_FIRSTNAME) {
          errors.Q_FIRSTNAME = "You must enter a first name.";
        }
        if (!data.Q_LASTNAME) {
          errors.Q_LASTNAME = "You must enter a last name.";
        }
        if (!data.Q_EMAIL) {
          errors.Q_EMAIL = "You must enter a valid email.";
        }
        if (data.Q_EMAIL && !data.Q_EMAIL.match(email_re)) {
          errors.Q_EMAIL = "You must enter a valid email address.";
        }
        if (!data.Q_ADDRESS1) {
          errors.Q_ADDRESS1 = "You must enter a mailing address.";
        }
        if (!data.Q_CITY) {
          errors.Q_CITY = "You must enter a city.";
        }
        console.log({ data });

        if (data.Q_DOB) {
          const segments = data.Q_DOB.split("/");
          console.log({ segments });
          if (segments.length === 3) {
            const month = parseInt(segments[0]);
            const day = parseInt(segments[1]);
            const year = parseInt(segments[2]);
            if (
              !month ||
              !day ||
              !year ||
              month < 0 ||
              month > 12 ||
              day < 0 ||
              day > 31 ||
              year < 0
            ) {
              errors.Q_DOB =
                "You must enter a date of birth in the format of MM/DD/YYYY.";
            } else {
              const age = getAge(month, day, year);

              if (age < 0 || age > 100) {
                errors.Q_DOB = "You must enter a valid year of birth.";
              } else if (age < 18) {
                errors.Q_DOB =
                  "Contrave is not approved for use in anyone under the age of 18.";
              }
            }
          } else {
            errors.Q_DOB =
              "You must enter a date of birth in the format of MM/DD/YYYY.";
          }
        } else {
          errors.Q_DOB =
            "You must enter a date of birth in the format of MM/DD/YYYY.";
        }
        if (!data.Q_GENDER) {
          errors.Q_GENDER = "You must enter a gender.";
        }
        if (!data.Q_STATE) {
          errors.Q_STATE = "You must select a state.";
        }
        if (!data.Q_MOBILE_PHONE) {
          errors.Q_MOBILE_PHONE =
            "You must enter a valid phone number in the format of ###-###-####.";
        } else if (!/^\d{3}-\d{3}-\d{4}$/.test(data.Q_MOBILE_PHONE)) {
          errors.Q_MOBILE_PHONE =
            "Please enter a 10-digit phone number in ###-###-#### format. Example: 123-456-7890";
        }
        if (
          !data.Q_ZIP ||
          !parseInt(data.Q_ZIP, 10) ||
          String(data.Q_ZIP).length !== 5
        ) {
          errors.Q_ZIP = "You must enter a valid 5-digit ZIP code.";
        }
        if (data.Q_PERM_OPT_IN !== "Y") {
          errors.Q_PERM_OPT_IN = "You must check the box to proceed.";
        }
        if (
          data.Q_CARD_ID &&
          (!parseInt(data.Q_CARD_ID, 10) || String(data.Q_CARD_ID).length != 10)
        ) {
          errors.Q_CARD_ID =
            "The card ID you entered is not valid for this program, please call 1-800-905-5576 to speak to a live agent to assist with enrollment.";
        }
        break;
      default:
        throw "Validation not found";
    }

    return errors;
  }
  /**
   * Validate the submitted data for the current step
   */
  validateNext() {
    const data = EnrollmentPage.prototype.getFormData();
    const current_step = EnrollmentPage.prototype.getCurrentStep();
    if (current_step !== "success_card" || current_step !== "existing_member") {
      const errors = EnrollmentPage.prototype.validate(current_step, data);
      if ($.isEmptyObject(errors)) {
        $(`section.${current_step} .btn`).removeClass("disabled");
      }
    }
  }
  handlePrint(e) {
    const params = getQueryParameters();
    const card_id = params.card_id || this.card_id;
    // eslint-disable-next-line no-undef
    const doc = new jsPDF();
    doc.setFontSize(10);
    doc.setFontStyle("bold");

    // eslint-disable-next-line no-undef
    doc.addImage(this.#savings_card, 60, 20, 104, 144);
    doc.text(card_id, 87, 71);

    const blob = doc.output("blob");
    const url = URL.createObjectURL(blob);

    // Reuse an iframe if it already exists
    let iframe = document.getElementById("pdf-print-frame");
    if (!iframe) {
      iframe = document.createElement("iframe");
      iframe.id = "pdf-print-frame";
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      document.body.appendChild(iframe);
    }

    iframe.onload = function () {
      // Wait a tick so the PDF viewer finishes initializing
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        // Optional: cleanup
        URL.revokeObjectURL(url);
      }, 100);
    };

    iframe.src = url;

    e.preventDefault();
  }
  handleDownloadPdf(e) {
    const params = getQueryParameters();
    const card_id = params.card_id || this.card_id;
    // eslint-disable-next-line no-undef
    const doc = new jsPDF();
    doc.setFontSize(10);
    doc.setFontStyle("bold");

    // eslint-disable-next-line no-undef
    doc.addImage(this.#savings_card, 60, 20, 104, 144);
    doc.text(card_id, 87, 71);

    doc.save("savings_card.pdf");

    e.preventDefault();
  }
  createCardImage(data) {
    const card_id = Array.isArray(data) ? data[0] : data;
    $.ajax({
      type: "POST",
      url: adminAjax,
      data: {
        action: "create_card_with_id",
        card_id,
      },
      success: (response) => {
        this.content = response;
        $("[data-download]").click((e) => {
          e.preventDefault();
          e.stopPropagation();
          this.downloadImage();
        });
      },
    });
  }
  downloadImage() {
    const linkSource = `data:image/jpeg;base64,${this.content}`;
    const downloadLink = document.createElement("a");
    const fileName = `Card.jpeg`;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }
  toggleVisibility(sectionKey, show) {
    const section = sections[sectionKey];
    if (section) {
      $(section.id).toggleClass("d-none", !show).toggleClass("d-flex", show);
      if (section.class) {
        $(`.${section.class}`)
          .toggleClass("d-none", !show)
          .toggleClass("d-flex", show);
      }
      if (section.modal) {
        if (show) {
          $(`#${section.modal}`).modal("show");
        }
      }
    }
  }
  showSection(sectionKey) {
    this.toggleVisibility(sectionKey, true);
  }
  hideSection(sectionKey) {
    this.toggleVisibility(sectionKey, false);
  }
  toggleNextStep(step) {
    console.log("toggle next step", step);
    Object.keys(sections).forEach((section) => {
      console.log({ section, step });
      if (
        step === "insurance" ||
        step === "contact" ||
        step === "insurance_none"
      ) {
        if (section === "insurance") {
          return;
        }
      }

      if (
        step === "ineligible" ||
        step === "contact" ||
        step === "insurance_none"
      ) {
        if (section === "insurance") {
          return;
        }
      }
      this.hideSection(section);
    });
    if ("ineligible" === step) {
      this.step = "insurance";
    }
    this.showSection(step);
  }
}

function getAge(month, day, year) {
  const today = new Date();
  let age = today.getFullYear() - year;
  const m = today.getMonth() - (month - 1);
  if (m < 0 || (m === 0 && today.getDate() < day)) {
    age--;
  }
  return age;
}

window.EnrollmentPage = EnrollmentPage;

if (window.savings_card) {
  window.enrollmentPage = new EnrollmentPage(window.savings_card);
}

/**
  const a = new Enrollment();
  a.createCardImage("1234");
  a.downloadImage();
 */
